(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty-minus], [data-cart-qty-plus]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('[data-cart-qty-input]');
    if (!input) return;
    var value = parseInt(input.value, 10) || 0;
    input.value = btn.hasAttribute('data-cart-qty-minus') ? Math.max(0, value - 1) : value + 1;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-collection-sort-select]')) {
      e.target.closest('[data-collection-sort-form]').submit();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
